export default function initFormWithCart(): void {
    const $archivePartenaires = document.querySelectorAll<HTMLElement>('.js-form-with-cart');
    $archivePartenaires.forEach($container => {
        new FormWithCart($container);
    });
}

interface Line {
    label?: string | null;
    price?: string | null;
}

class FormWithCart {
    $el: HTMLElement;
    $asideElement: Element | null;
    $asideTitleElement: Element | null;
    $totalHTElement: Element | null;
    $totalTVAElement: Element | null;
    $totalPriceElement: Element | null;
    $totalPrice: number;
    $inputsWithPrices: NodeListOf<HTMLInputElement>;
    $inputsWithDiscounts: NodeListOf<HTMLInputElement>;
    $lines: Line[];
    $discounts: Line[];
    $formFieldTotal: HTMLInputElement | null;
    
    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$asideElement = this.$el.querySelector('.aside-form-price');
        this.$asideTitleElement = this.$el.querySelector('.aside-form-price .title');
        this.$totalHTElement = this.$el.querySelector('.aside-form-price .total-ht');
        this.$totalTVAElement = this.$el.querySelector('.aside-form-price .total-tva');
        this.$totalPriceElement = this.$el.querySelector('.aside-form-price .total-price');
        this.$totalPrice = 0;
        this.$inputsWithPrices = this.$el.querySelectorAll('[data-frmprice]:not([data-frmprice*="%"]):not([data-frmprice=""])');
        this.$inputsWithDiscounts = this.$el.querySelectorAll('.discount [data-frmprice]');
        this.$lines = [];
        this.$discounts = [];
        this.$formFieldTotal = this.$el.querySelector('[id^="field_total"]');
        this.init();
    }

    init(): void {
        this.$inputsWithPrices.forEach((input: HTMLInputElement) => {
            input.addEventListener('change', () => {
                this.generateLines();
            });
        });

        this.$inputsWithDiscounts.forEach((input: HTMLInputElement) => {
            input.addEventListener('change', () => {
                this.generateLines();
            });
        });

        document.addEventListener('DOMContentLoaded', () => {
            this.generateLines();
        });
    }

    calculatePrices(): void {
        this.$lines = [];
        this.$totalPrice = 0;
        this.$inputsWithPrices.forEach((input: HTMLInputElement) => {
            if (input.checked) {
                const line: Line = {};
                const labelLineElement = input.parentElement?.querySelector('.short');
                line.label = labelLineElement ? labelLineElement.textContent : null;
                const priceLineElement = input.parentElement?.querySelector('.price');
                line.price = priceLineElement ? priceLineElement.textContent || "0 €" : null;
                
                this.$lines.push(line);

                const priceElement = input.parentElement ? input.parentElement.querySelector('.price') : null;
                const price = priceElement ? parseInt(priceElement.textContent || '0') : 0;
                this.$totalPrice += price;
            }
        });
        
    }

    calculateDiscounts(): void {
        this.$discounts = [];
        this.$inputsWithDiscounts.forEach((input: HTMLInputElement) => {
            if (input.checked) {
                const line: Line = {};
                const labelLineElement = input.parentElement?.querySelector('.label');
                line.label = labelLineElement ? labelLineElement.textContent : null;
                const priceLineElement = input.parentElement?.querySelector('.price');
                line.price = priceLineElement ? priceLineElement.textContent : null;
                
                this.$discounts.push(line);

                const priceElement = input.parentElement ? input.parentElement.querySelector('.price') : null;
                
                const price = priceElement ? parseInt(priceElement.textContent || '0') : 0;
                
                this.$totalPrice *= ((100 - Math.abs(price)) / 100);
            }
        });
    }

    renderItems(items: Line[], containerElement:HTMLElement): HTMLElement {
        
        items.forEach((item: Line) => {
            if (item.price !== undefined && item.price !== null && item.price !== '' && item.price !== '0€') {
                const liElement = document.createElement('li');
                liElement.className = 'line';

                const labelDiv = document.createElement('div');
                labelDiv.className = 'article';
                labelDiv.textContent = item.label || '';

                const priceDiv = document.createElement('div');
                priceDiv.className = 'article-price';
                priceDiv.textContent = item.price || '';

                liElement.appendChild(labelDiv);
                liElement.appendChild(priceDiv);

                containerElement.appendChild(liElement);
            }
        });

        return containerElement;
    }

    generateLines(): void {
        this.calculatePrices();
        this.calculateDiscounts();
        
        if (this.$lines.length) {
            const containerElement = document.createElement('ul');
            containerElement.classList.add('lines', 'generated');

            this.renderItems(this.$lines, containerElement);
            this.renderItems(this.$discounts, containerElement);
            
            if (this.$asideElement && this.$asideTitleElement) {
                this.$asideElement?.querySelector('.generated')?.remove();
                this.$asideElement.insertBefore(containerElement, this.$asideTitleElement.nextSibling);
            }
            
            if (this.$totalHTElement) {
                this.$totalHTElement.innerHTML = Math.round(this.$totalPrice) +' €';
            }

            if (this.$totalTVAElement) {
                const tva = parseFloat((this.$totalPrice * 0.2).toFixed(2));
                this.$totalTVAElement.innerHTML = tva +' €';
            }

            if (this.$totalPriceElement) {
                this.$totalPriceElement.innerHTML = parseFloat((this.$totalPrice * 1.2).toFixed(2)) +' €';
            }

            if (this.$formFieldTotal) {
                this.$formFieldTotal.value = parseFloat((this.$totalPrice * 1.2).toFixed(2)) +' €';
            }
        }
    }
}